// Entity
import { TaskBuilder } from "../../legacyPlanner/task/TaskBuilder";
import { PreviewTypeConverter } from "../../legacyPlanner/previewType/PreviewType";
import { TaskCreationSource } from "../../legacyPlanner/task/creationSource/TaskCreationSource";
// Utilities
import { getCurrentDateWithoutTimestamp } from "@ms/uno-utilities/lib/local/DateUtilities";
import moment from "moment";
/** Class to handle serialization/deserialization for task data */ export class TasksSerializationHandler {
    /** serialize to ITaskPersistedResource */ toSerializable(key, value) {
        const taskGraphResource = value.toGraphSerializable();
        return {
            ...taskGraphResource,
            hasDescription: value.hasDescription,
            previewType: PreviewTypeConverter.getGraphPreviewType(value.previewType),
            createdDateTime: value.createdDate ? value.createdDate.clone().utc().toISOString() : undefined,
            completedDateTime: value.completedDate ? value.completedDate.clone().utc().toISOString() : undefined,
            referenceCount: value.numberOfReferences,
            createdBy: value.createdBy ? {
                user: {
                    displayName: null,
                    id: value.createdBy
                }
            } : undefined,
            checklistItemCount: value.numberOfChecklistItems,
            activeChecklistItemCount: value.numberOfActiveChecklistItems,
            creationSource: TaskCreationSource.toGraphResource(value.creationSource),
            myDayDate: taskGraphResource.isOnMyDay ? getCurrentDateWithoutTimestamp() : "",
            assigneeIds: taskGraphResource.assignments ? Object.keys(taskGraphResource.assignments) : [],
            kind: value.kind,
            userContentLastModifiedBy: value.userContentLastModifiedBy,
            userContentLastModifiedDate: value.userContentLastModifiedDate ? value.userContentLastModifiedDate.clone().utc().toISOString() : undefined
        };
    }
    /** build ITask from ITaskPersistedResource */ fromSerializable(key, serializableValue) {
        return new TaskBuilder().fromGraphResource(serializableValue).withPropertyBag({
            kind: serializableValue.kind ?? undefined,
            id: serializableValue.id,
            planId: serializableValue.planId,
            title: serializableValue.title,
            bucketId: serializableValue.bucketId,
            userContentLastModifiedBy: serializableValue.userContentLastModifiedBy ?? "",
            userContentLastModifiedDate: serializableValue.userContentLastModifiedDate ? moment(serializableValue.userContentLastModifiedDate) : undefined
        }).build();
    }
}
